import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {TableActionFunctionParameters} from 'notebook/structured-tables/StructuredTableConstants';
import TableValidationBypassTooltip from 'notebook/tables/core-ui/TableValidationBypassTooltip';
import {getEvaluatedRowErrors, getUniqueErrorMessages} from 'notebook/tables/errors/ErrorUtil';
import {TableIndicatorStatus} from 'notebook/tables/TableConstants';
import APIUtil from 'util/APIUtil';

export interface TableActionButtonDisabledTooltipProps<TTableMetadata, TRowMetadata> extends Pick<
  TableActionFunctionParameters<TTableMetadata, TRowMetadata>,
  'entryOrTemplateId' | 'structuredTable' | 'table' | 'locked' | 'tableStatus' | 'updateHandler'
> {}

/**
 * Returns the Tooltip text for the button if disabled, or null if button is enabled.
 * Mirrors ./isTableActionButtonDisabled.ts when determining if button should be disabled.
 */
export default function tableActionButtonDisabledTooltip<TTableMetadata, TRowMetadata>({
  entryOrTemplateId,
  structuredTable,
  table,
  locked,
  tableStatus,
  updateHandler,
}: TableActionButtonDisabledTooltipProps<TTableMetadata, TRowMetadata>): string | null | JSX.Element {
  if (entryOrTemplateId != null && APIUtil.isEntryOrSubOrWorkflowTemplate(entryOrTemplateId)) {
    return 'Submission not allowed in templates';
  } else if (tableStatus === TableIndicatorStatus.ERROR) {
    return 'Table contains validation error(s)';
  } else if (tableStatus === TableIndicatorStatus.TABLE_OR_SCHEMA_ARCHIVED) {
    return 'Table or schema is archived';
  } else if (tableStatus === TableIndicatorStatus.HAS_BYPASSABLE_ERRORS) {
    return (
      <TableValidationBypassTooltip
        errors={getUniqueErrorMessages(getEvaluatedRowErrors(table))}
        showFilterButton={BenchlingConfig.ELN_ENABLE_STRUCTURED_TABLE_STATUS_FILTERING}
        structuredTable={structuredTable}
        updateHandler={updateHandler}
      />
    );
  } else if (tableStatus === TableIndicatorStatus.SUBMITTED_BYPASSING_VALIDATION) {
    // TODO verbiage TBD
    return 'Submitted bypassing validation';
  } else if (locked) {
    return 'Table is locked';
  } else if (tableStatus !== TableIndicatorStatus.UNSUBMITTED_CHANGES) {
    return 'All changes have been submitted';
  } else {
    return null;
  }
}
